import { defineComponent as re, inject as ne, computed as c, ref as x, watchEffect as S, toRef as U, provide as ie, h as I } from "vue";
import { layoutSiderInjectionKey as le } from "./ghl-ui.es1042.js";
import { isIgnoredNode as V, itemRenderer as ce } from "./ghl-ui.es1043.js";
import { useCheckDeprecated as ae } from "./ghl-ui.es1044.js";
import { menuInjectionKey as de } from "./ghl-ui.es1045.js";
import { NSubmenu as B } from "./ghl-ui.es1046.js";
import ve from "./ghl-ui.es1047.js";
import me from "./ghl-ui.es854.js";
import M from "./ghl-ui.es855.js";
import { createTreeMate as N } from "./ghl-ui.es871.js";
import O from "./ghl-ui.es712.js";
import se from "./ghl-ui.es714.js";
import { call as s } from "./ghl-ui.es876.js";
import { useThemeClass as ue } from "./ghl-ui.es857.js";
import { createId as he } from "./ghl-ui.es939.js";
import fe from "./ghl-ui.es887.js";
import Ce from "./ghl-ui.es1048.js";
import pe from "./ghl-ui.es1049.js";
const xe = Object.assign(Object.assign({}, M.props), {
  options: {
    type: Array,
    default: () => []
  },
  collapsed: {
    type: Boolean,
    default: void 0
  },
  collapsedWidth: {
    type: Number,
    default: 48
  },
  iconSize: {
    type: Number,
    default: 20
  },
  collapsedIconSize: {
    type: Number,
    default: 24
  },
  rootIndent: Number,
  indent: {
    type: Number,
    default: 32
  },
  labelField: {
    type: String,
    default: "label"
  },
  keyField: {
    type: String,
    default: "key"
  },
  childrenField: {
    type: String,
    default: "children"
  },
  disabledField: {
    type: String,
    default: "disabled"
  },
  defaultExpandAll: Boolean,
  defaultExpandedKeys: Array,
  expandedKeys: Array,
  value: [String, Number],
  defaultValue: {
    type: [String, Number],
    default: null
  },
  mode: {
    type: String,
    default: "vertical"
  },
  watchProps: {
    type: Array,
    default: void 0
  },
  disabled: Boolean,
  show: {
    type: Boolean,
    default: !0
  },
  inverted: Boolean,
  "onUpdate:expandedKeys": [Function, Array],
  onUpdateExpandedKeys: [Function, Array],
  onUpdateValue: [Function, Array],
  "onUpdate:value": [Function, Array],
  expandIcon: Function,
  renderIcon: Function,
  renderLabel: Function,
  renderExtra: Function,
  dropdownProps: Object,
  accordion: Boolean,
  nodeProps: Function,
  dropdownPlacement: {
    type: String,
    default: "bottom"
  },
  responsive: Boolean,
  // deprecated
  items: Array,
  onOpenNamesChange: [Function, Array],
  onSelect: [Function, Array],
  onExpandedNamesChange: [Function, Array],
  expandedNames: Array,
  defaultExpandedNames: Array
}), Ve = re({
  name: "Menu",
  props: xe,
  setup(n) {
    process.env.NODE_ENV !== "production" && ae(n);
    const {
      mergedClsPrefixRef: v,
      inlineThemeDisabled: y
    } = me(n), m = M("Menu", "-menu", ve, Ce, n, v), f = ne(le, null), g = c(() => {
      var t;
      const {
        collapsed: i
      } = n;
      if (i !== void 0)
        return i;
      if (f) {
        const {
          collapseModeRef: e,
          collapsedRef: r
        } = f;
        if (e.value === "width")
          return (t = r.value) !== null && t !== void 0 ? t : !1;
      }
      return !1;
    }), a = c(() => {
      const {
        keyField: t,
        childrenField: i,
        disabledField: e
      } = n;
      return N(n.items || n.options, {
        getIgnored(r) {
          return V(r);
        },
        getChildren(r) {
          return r[i];
        },
        getDisabled(r) {
          return r[e];
        },
        getKey(r) {
          var l;
          return (l = r[t]) !== null && l !== void 0 ? l : r.name;
        }
      });
    }), u = c(() => new Set(a.value.treeNodes.map((t) => t.key))), {
      watchProps: d
    } = n, C = x(null);
    d != null && d.includes("defaultValue") ? S(() => {
      C.value = n.defaultValue;
    }) : C.value = n.defaultValue;
    const k = U(n, "value"), p = O(k, C), A = x([]), T = () => {
      A.value = n.defaultExpandAll ? a.value.getNonLeafKeys() : n.defaultExpandedNames || n.defaultExpandedKeys || a.value.getPath(p.value, {
        includeSelf: !1
      }).keyPath;
    };
    d != null && d.includes("defaultExpandedKeys") ? S(T) : T();
    const b = se(n, ["expandedNames", "expandedKeys"]), z = O(b, A), j = c(() => a.value.treeNodes), w = c(() => a.value.getPath(p.value).keyPath);
    ie(de, {
      props: n,
      mergedCollapsedRef: g,
      mergedThemeRef: m,
      mergedValueRef: p,
      mergedExpandedKeysRef: z,
      activePathRef: w,
      mergedClsPrefixRef: v,
      isHorizontalRef: c(() => n.mode === "horizontal"),
      invertedRef: U(n, "inverted"),
      doSelect: $,
      toggleExpand: D
    });
    function $(t, i) {
      const {
        "onUpdate:value": e,
        onUpdateValue: r,
        onSelect: l
      } = n;
      r && s(r, t, i), e && s(e, t, i), l && s(l, t, i), C.value = t;
    }
    function E(t) {
      const {
        "onUpdate:expandedKeys": i,
        onUpdateExpandedKeys: e,
        onExpandedNamesChange: r,
        onOpenNamesChange: l
      } = n;
      i && s(i, t), e && s(e, t), r && s(r, t), l && s(l, t), A.value = t;
    }
    function D(t) {
      const i = Array.from(z.value), e = i.findIndex((r) => r === t);
      if (~e)
        i.splice(e, 1);
      else {
        if (n.accordion && u.value.has(t)) {
          const r = i.findIndex((l) => u.value.has(l));
          r > -1 && i.splice(r, 1);
        }
        i.push(t);
      }
      E(i);
    }
    const G = (t) => {
      const i = a.value.getPath(t ?? p.value, {
        includeSelf: !1
      }).keyPath;
      if (!i.length)
        return;
      const e = Array.from(z.value), r = /* @__PURE__ */ new Set([...e, ...i]);
      n.accordion && u.value.forEach((l) => {
        r.has(l) && !i.includes(l) && r.delete(l);
      }), E(Array.from(r));
    }, K = c(() => {
      const {
        inverted: t
      } = n, {
        common: {
          cubicBezierEaseInOut: i
        },
        self: e
      } = m.value, {
        borderRadius: r,
        borderColorHorizontal: l,
        fontSize: ee,
        itemHeight: oe,
        dividerColor: te
      } = e, o = {
        "--n-divider-color": te,
        "--n-bezier": i,
        "--n-font-size": ee,
        "--n-border-color-horizontal": l,
        "--n-border-radius": r,
        "--n-item-height": oe
      };
      return t ? (o["--n-group-text-color"] = e.groupTextColorInverted, o["--n-color"] = e.colorInverted, o["--n-item-text-color"] = e.itemTextColorInverted, o["--n-item-text-color-hover"] = e.itemTextColorHoverInverted, o["--n-item-text-color-active"] = e.itemTextColorActiveInverted, o["--n-item-text-color-child-active"] = e.itemTextColorChildActiveInverted, o["--n-item-text-color-child-active-hover"] = e.itemTextColorChildActiveInverted, o["--n-item-text-color-active-hover"] = e.itemTextColorActiveHoverInverted, o["--n-item-icon-color"] = e.itemIconColorInverted, o["--n-item-icon-color-hover"] = e.itemIconColorHoverInverted, o["--n-item-icon-color-active"] = e.itemIconColorActiveInverted, o["--n-item-icon-color-active-hover"] = e.itemIconColorActiveHoverInverted, o["--n-item-icon-color-child-active"] = e.itemIconColorChildActiveInverted, o["--n-item-icon-color-child-active-hover"] = e.itemIconColorChildActiveHoverInverted, o["--n-item-icon-color-collapsed"] = e.itemIconColorCollapsedInverted, o["--n-item-text-color-horizontal"] = e.itemTextColorHorizontalInverted, o["--n-item-text-color-hover-horizontal"] = e.itemTextColorHoverHorizontalInverted, o["--n-item-text-color-active-horizontal"] = e.itemTextColorActiveHorizontalInverted, o["--n-item-text-color-child-active-horizontal"] = e.itemTextColorChildActiveHorizontalInverted, o["--n-item-text-color-child-active-hover-horizontal"] = e.itemTextColorChildActiveHoverHorizontalInverted, o["--n-item-text-color-active-hover-horizontal"] = e.itemTextColorActiveHoverHorizontalInverted, o["--n-item-icon-color-horizontal"] = e.itemIconColorHorizontalInverted, o["--n-item-icon-color-hover-horizontal"] = e.itemIconColorHoverHorizontalInverted, o["--n-item-icon-color-active-horizontal"] = e.itemIconColorActiveHorizontalInverted, o["--n-item-icon-color-active-hover-horizontal"] = e.itemIconColorActiveHoverHorizontalInverted, o["--n-item-icon-color-child-active-horizontal"] = e.itemIconColorChildActiveHorizontalInverted, o["--n-item-icon-color-child-active-hover-horizontal"] = e.itemIconColorChildActiveHoverHorizontalInverted, o["--n-arrow-color"] = e.arrowColorInverted, o["--n-arrow-color-hover"] = e.arrowColorHoverInverted, o["--n-arrow-color-active"] = e.arrowColorActiveInverted, o["--n-arrow-color-active-hover"] = e.arrowColorActiveHoverInverted, o["--n-arrow-color-child-active"] = e.arrowColorChildActiveInverted, o["--n-arrow-color-child-active-hover"] = e.arrowColorChildActiveHoverInverted, o["--n-item-color-hover"] = e.itemColorHoverInverted, o["--n-item-color-active"] = e.itemColorActiveInverted, o["--n-item-color-active-hover"] = e.itemColorActiveHoverInverted, o["--n-item-color-active-collapsed"] = e.itemColorActiveCollapsedInverted) : (o["--n-group-text-color"] = e.groupTextColor, o["--n-color"] = e.color, o["--n-item-text-color"] = e.itemTextColor, o["--n-item-text-color-hover"] = e.itemTextColorHover, o["--n-item-text-color-active"] = e.itemTextColorActive, o["--n-item-text-color-child-active"] = e.itemTextColorChildActive, o["--n-item-text-color-child-active-hover"] = e.itemTextColorChildActiveHover, o["--n-item-text-color-active-hover"] = e.itemTextColorActiveHover, o["--n-item-icon-color"] = e.itemIconColor, o["--n-item-icon-color-hover"] = e.itemIconColorHover, o["--n-item-icon-color-active"] = e.itemIconColorActive, o["--n-item-icon-color-active-hover"] = e.itemIconColorActiveHover, o["--n-item-icon-color-child-active"] = e.itemIconColorChildActive, o["--n-item-icon-color-child-active-hover"] = e.itemIconColorChildActiveHover, o["--n-item-icon-color-collapsed"] = e.itemIconColorCollapsed, o["--n-item-text-color-horizontal"] = e.itemTextColorHorizontal, o["--n-item-text-color-hover-horizontal"] = e.itemTextColorHoverHorizontal, o["--n-item-text-color-active-horizontal"] = e.itemTextColorActiveHorizontal, o["--n-item-text-color-child-active-horizontal"] = e.itemTextColorChildActiveHorizontal, o["--n-item-text-color-child-active-hover-horizontal"] = e.itemTextColorChildActiveHoverHorizontal, o["--n-item-text-color-active-hover-horizontal"] = e.itemTextColorActiveHoverHorizontal, o["--n-item-icon-color-horizontal"] = e.itemIconColorHorizontal, o["--n-item-icon-color-hover-horizontal"] = e.itemIconColorHoverHorizontal, o["--n-item-icon-color-active-horizontal"] = e.itemIconColorActiveHorizontal, o["--n-item-icon-color-active-hover-horizontal"] = e.itemIconColorActiveHoverHorizontal, o["--n-item-icon-color-child-active-horizontal"] = e.itemIconColorChildActiveHorizontal, o["--n-item-icon-color-child-active-hover-horizontal"] = e.itemIconColorChildActiveHoverHorizontal, o["--n-arrow-color"] = e.arrowColor, o["--n-arrow-color-hover"] = e.arrowColorHover, o["--n-arrow-color-active"] = e.arrowColorActive, o["--n-arrow-color-active-hover"] = e.arrowColorActiveHover, o["--n-arrow-color-child-active"] = e.arrowColorChildActive, o["--n-arrow-color-child-active-hover"] = e.arrowColorChildActiveHover, o["--n-item-color-hover"] = e.itemColorHover, o["--n-item-color-active"] = e.itemColorActive, o["--n-item-color-active-hover"] = e.itemColorActiveHover, o["--n-item-color-active-collapsed"] = e.itemColorActiveCollapsed), o;
    }), h = y ? ue("menu", c(() => n.inverted ? "a" : "b"), K, n) : void 0, R = he(), F = x(null), L = x(null);
    let _ = !0;
    const P = () => {
      var t;
      _ ? _ = !1 : (t = F.value) === null || t === void 0 || t.sync({
        showAllItemsBeforeCalculate: !0
      });
    };
    function W() {
      return document.getElementById(R);
    }
    const H = x(-1);
    function q(t) {
      H.value = n.options.length - t;
    }
    function J(t) {
      t || (H.value = -1);
    }
    const Q = c(() => {
      const t = H.value;
      return {
        children: t === -1 ? [] : n.options.slice(t)
      };
    }), X = c(() => {
      const {
        childrenField: t,
        disabledField: i,
        keyField: e
      } = n;
      return N([Q.value], {
        getIgnored(r) {
          return V(r);
        },
        getChildren(r) {
          return r[t];
        },
        getDisabled(r) {
          return r[i];
        },
        getKey(r) {
          var l;
          return (l = r[e]) !== null && l !== void 0 ? l : r.name;
        }
      });
    }), Y = c(() => N([{}]).treeNodes[0]);
    function Z() {
      var t;
      if (H.value === -1)
        return I(B, {
          root: !0,
          level: 0,
          key: "__ellpisisGroupPlaceholder__",
          internalKey: "__ellpisisGroupPlaceholder__",
          title: "···",
          tmNode: Y.value,
          domId: R,
          isEllipsisPlaceholder: !0
        });
      const i = X.value.treeNodes[0], e = w.value, r = !!(!((t = i.children) === null || t === void 0) && t.some((l) => e.includes(l.key)));
      return I(B, {
        level: 0,
        root: !0,
        key: "__ellpisisGroup__",
        internalKey: "__ellpisisGroup__",
        title: "···",
        virtualChildActive: r,
        tmNode: i,
        domId: R,
        rawNodes: i.rawNode.children || [],
        tmNodes: i.children || [],
        isEllipsisPlaceholder: !0
      });
    }
    return {
      mergedClsPrefix: v,
      controlledExpandedKeys: b,
      uncontrolledExpanededKeys: A,
      mergedExpandedKeys: z,
      uncontrolledValue: C,
      mergedValue: p,
      activePath: w,
      tmNodes: j,
      mergedTheme: m,
      mergedCollapsed: g,
      cssVars: y ? void 0 : K,
      themeClass: h == null ? void 0 : h.themeClass,
      overflowRef: F,
      counterRef: L,
      updateCounter: () => {
      },
      onResize: P,
      onUpdateOverflow: J,
      onUpdateCount: q,
      renderCounter: Z,
      getCounter: W,
      onRender: h == null ? void 0 : h.onRender,
      showOption: G,
      deriveResponsiveState: P
    };
  },
  render() {
    const {
      mergedClsPrefix: n,
      mode: v,
      themeClass: y,
      onRender: m
    } = this;
    m == null || m();
    const f = () => this.tmNodes.map((d) => ce(d, this.$props)), a = v === "horizontal" && this.responsive, u = () => I("div", {
      role: v === "horizontal" ? "menubar" : "menu",
      class: [`${n}-menu`, y, `${n}-menu--${v}`, a && `${n}-menu--responsive`, this.mergedCollapsed && `${n}-menu--collapsed`],
      style: this.cssVars
    }, a ? I(pe, {
      ref: "overflowRef",
      onUpdateOverflow: this.onUpdateOverflow,
      getCounter: this.getCounter,
      onUpdateCount: this.onUpdateCount,
      updateCounter: this.updateCounter,
      style: {
        width: "100%",
        display: "flex",
        overflow: "hidden"
      }
    }, {
      default: f,
      counter: this.renderCounter
    }) : f());
    return a ? I(fe, {
      onResize: this.onResize
    }, {
      default: u
    }) : u();
  }
});
export {
  Ve as default,
  xe as menuProps
};
